/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Connectionstatus_Boxdisconnected2Inputs */



/**
* | output |
* | --- |
* | "Box disconnected" |
*
* @param {Alarms_Connectionstatus_Boxdisconnected2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_connectionstatus_boxdisconnected2 = /** @type {((inputs?: Alarms_Connectionstatus_Boxdisconnected2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Connectionstatus_Boxdisconnected2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Box disconnected")
	return /** @type {LocalizedString} */ ("Box déconnectée")
});
export { alarms_connectionstatus_boxdisconnected2 as "alarms_connectionStatus_boxDisconnected" }